import React, {PureComponent, ReactNode} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

export default class FastRegistrationDescription extends PureComponent {
    render(): ReactNode {
        return <div className="description-content-box">
            <span className="title-span">{I18n.t('registration_info_title')}</span>
            <ul className="description-list-box">
                <li>
                    <span className="icon-box">
                        <SpriteIcon name="#svg-reg-icon-1" className="svg-default" />
                    </span>
                    <div className="description-box">
                        <span className="description-box-title">{I18n.t('registration_info_title_1')}</span>
                        <p className="description-box-text">{I18n.t('registration_info_text_1')}</p>
                    </div>
                </li>
                <li>
                    <span className="icon-box">
                        <SpriteIcon name="#svg-reg-icon-2" className="svg-default" />
                    </span>
                    <div className="description-box">
                        <span className="description-box-title">{I18n.t('registration_info_title_2')}</span>
                        <p className="description-box-text">{I18n.t('registration_info_text_2')}</p>
                    </div>
                </li>
                <li>
                    <span className="icon-box">
                        <SpriteIcon name="#svg-reg-icon-3" className="svg-default"/>
                    </span>
                    <div className="description-box">
                        <span className="description-box-title">{I18n.t('registration_info_title_3')}</span>
                        <p className="description-box-text">{I18n.t('registration_info_text_3')}</p>
                    </div>
                </li>
            </ul>
        </div>;
    }
}
